function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Refresh(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M19.488 11.67A7.5 7.5 0 016.7 17.393l.021 2.328a.475.475 0 01-.45.45.398.398 0 01-.42-.419l.004-3.912 3.913-.003a.398.398 0 01.418.418.475.475 0 01-.45.451l-2.33-.022.166.16a6.5 6.5 0 0010.918-5.12.5.5 0 01.998-.056zM17.73 4a.397.397 0 01.415.341l.004.078-.003 3.913-3.913.003a.398.398 0 01-.418-.419.477.477 0 01.372-.44l.078-.01 2.329.02-.165-.158a6.5 6.5 0 00-10.918 5.12.5.5 0 01-.998.056A7.5 7.5 0 0117.3 6.78l-.022-2.33a.475.475 0 01.45-.45z"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(Refresh);
export default ForwardRef;